import { z } from 'zod'

/** Returns the start of today in UTC (midnight UTC) for date comparison. */
export function utcTodayEnd(): Date {
  const now = new Date()
  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 23, 59, 59, 999))
}

export const createPenaltyTypeSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  category: z.string().optional(),
})

export type CreatePenaltyTypeFormData = z.infer<typeof createPenaltyTypeSchema>

export const createPenaltyEntrySchema = z
  .object({
    useCustomType: z.boolean(),
    penaltyTypeId: z.string().optional(),
    customTypeName: z.string().optional(),
    userId: z.string().min(1, 'Employee is required'),
    amount: z
      .number({ message: 'Amount must be a number' })
      .min(0.01, 'Amount must be at least 0.01'),
    currency: z.string().min(1, 'Currency is required'),
    penaltyDate: z
      .string()
      .min(1, 'Date is required')
      .refine((val) => {
        const d = new Date(val)
        return !isNaN(d.getTime())
      }, 'Invalid date')
      .refine((val) => {
        const inputDay = new Date(val)
        const today = utcTodayEnd()
        return inputDay <= today
      }, 'Penalty date cannot be in the future'),
    reason: z.string().optional(),
  })
  .refine(
    (data) => {
      if (data.useCustomType) return (data.customTypeName ?? '').trim().length > 0
      return (data.penaltyTypeId ?? '').length > 0
    },
    {
      message: 'Select a penalty type or enter a custom type name',
      path: ['penaltyTypeId'],
    },
  )

export type CreatePenaltyEntryFormData = z.infer<typeof createPenaltyEntrySchema>
